import { registerMessages } from "../../i18n/runtime";
import { accountingEn } from "./messages.en";
import { accountingEs } from "./messages.es";

registerMessages("en", accountingEn);
registerMessages("es", accountingEs);
